export const toggleSetValue = <T>(values: Set<T>, value: T): Set<T> => {
  const next = new Set(values);

  if (next.has(value)) {
    next.delete(value);
  } else {
    next.add(value);
  }

  return next;
};
